import config from '@/config';

export const buildLobbyUrl = (region?: string): string => {
  const resolvedRegion =
    (region ?? '').toUpperCase() || config.defaultRegion || '';
  let lobbyUrl = config.casinoWebUrl ?? '';

  const domain = config.domain;
  const env = config.env;

  if (env && /devstack/.test(env) && /{namespace}/.test(lobbyUrl)) {
    const devstackName =
      typeof window !== 'undefined'
        ? window.location.hostname.split(`.${domain}`)[0].split('.gw').join('')
        : '';
    lobbyUrl = lobbyUrl.replace(/{namespace}/g, devstackName);
  }

  if (resolvedRegion) {
    lobbyUrl = lobbyUrl.replace(/{region}/gi, resolvedRegion.toLowerCase());
  }

  return lobbyUrl;
};
